
import { Options, Vue } from 'vue-class-component';
import HelloWorld from '../../components/HelloWorld.vue';
import { DataUtil } from '@/util/DataUtil';
import { userPrivacyConfigVivoAudit } from "@/config/template_new_user_privacy_vivo_audit";

@Options({
    components: {
        HelloWorld,
    }
})
export default class App extends Vue {

    private temp: string = userPrivacyConfigVivoAudit.template_new_protocol_20230926;

    private config: TemplateInterface = {
        productName: '好剧时刻',
        companyFullName: '海南耀天网络技术有限公司',
        companyShortName: '海南耀天',
        practicalCompanyName: "海南杉木网络技术有限公司",
        IcpNumber: "琼ICP备20000955号-3",
        officialWebsite: 'http://yaotkj.com/',
        mail: "2581786904@qq.com",
        cashConfig: ``
    };

    mounted() {
        this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
}
